<script setup lang="ts">
import { screenSizesInPixels } from '~~/utils';

const props = defineProps<{
	count?: number;
}>();

const breakpoints = useBreakpoints(screenSizesInPixels);

const defaultCount = computed(() => {
	if (breakpoints.smaller('md').value) return 6; // 3 rows * 2 cols = 6 items
	if (breakpoints.smaller('lg').value) return 9; // 3 rows * 3 cols = 9 items
	return 12; // 3 rows * 4 cols = 12 items
});

/**
 * Desk: 4 itens cada linha -> 12
 * Tablet: 3 itens cada linha -> 9
 * Mobile: 2 itens cada linha -> 4 (ou 6 dependendo se '3 colunas' significa 3 linhas)
 */
const effectiveCount = computed(() => props.count ?? defaultCount.value);
</script>

<template>
	<div class="flex w-full flex-col gap-6">
		<div class="grid grid-cols-2 gap-[2px] md:grid-cols-3 lg:grid-cols-4">
			<div
				v-for="i in effectiveCount"
				:key="i"
				class="flex aspect-9/14 flex-col overflow-hidden"
			>
				<div class="flex flex-1 animate-pulse bg-primary-light-4" />
			</div>
		</div>
	</div>
</template>
